import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2
            className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            内容分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            涵盖P站视频各个维度的使用指南，点击分类进入专题页面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}